export default {
  setSubscriptions(state, subscriptions) {
    state.subscriptions = subscriptions;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setOverview(state, overview) {
    state.overview = overview;
  }
};
